const NAME = 'wc_subscription_period';
AC_SERVICES.addListener('Editing.Editables.Ready', (Editables) => {
    const Abstract = Editables.get('_abstract');
    class SubscriptionPeriod extends Abstract {
        getEditableType() {
            return NAME;
        }
        focus() {
            this.getElement().querySelector('select[name="interval"]').focus();
        }
        render() {
            let interval_select = this.getElement().querySelector('select[name="interval"]');
            if (interval_select) {
                this.popuplateSelect(interval_select, this.settings.intervals);
            }
            let period_select = this.getElement().querySelector('select[name="period"]');
            if (period_select) {
                this.popuplateSelect(period_select, this.settings.periods);
            }
        }
        valueToInput(value) {
            if (!value) {
                return;
            }
            let interval_select = this.getElement().querySelector('select[name="interval"]');
            if (interval_select && value.hasOwnProperty('interval')) {
                interval_select.value = value.interval;
            }
            let period_select = this.getElement().querySelector('select[name="period"]');
            if (period_select && value.hasOwnProperty('interval')) {
                period_select.value = value.period;
            }
        }
        popuplateSelect(select, options) {
            Object.keys(options).forEach((k) => {
                let el = document.createElement('option');
                el.setAttribute('value', k);
                el.innerText = options[k];
                select.append(el);
            });
        }
        getValue() {
            return {
                interval: this.getElement().querySelector('[name=interval]').value,
                period: this.getElement().querySelector('[name=period]').value,
            };
        }
        getTemplate() {
            return `	
				<div class="input__group">
					<select name="interval"  class="select__medium"></select>&nbsp;
					<select name="period"  class="select__medium"></select>
				</div>
			`;
        }
    }
    Editables.registerEditable(NAME, SubscriptionPeriod);
});
// Register MiddleWare
AC_SERVICES.addListener('Editing.Middleware.Ready', (Middleware) => {
    const Abstract = Middleware.getClass('_abstract');
    class SubscriptionPeriod extends Abstract {
        getEditable() {
            return this.Editables.get(NAME);
        }
        map() {
            this.args.periods = this.settings.period_options;
            this.args.intervals = this.settings.interval_options;
            return this.args;
        }
    }
    Middleware.register(NAME, SubscriptionPeriod);
});
export {};
